export enum EntregaStatus {
  AGUARDANDO_AVALIACAO = 'AGUARDANDO_AVALIACAO',
  CORRECAO_PENDENTE_ALUNO = 'CORRECAO_PENDENTE_ALUNO',
  EM_RECUPERACAO = 'EM_RECUPERACAO',
  EXPIRADO = 'EXPIRADO',
  NAO_INICIADO = 'NAO_INICIADO',
  PUBLICADO = 'PUBLICADO',
  RASCUNHO = 'RASCUNHO',
}
